import { FormEvent, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { useConsoleAuthStore } from "store/useConsoleAuthStore";
import { usePostLogin } from "hooks/console/usePostLogin";
import Logo from "assets/logo/logo.png";
import MainImage from "assets/console/login_main_img.jpg";
import { ReactComponent as Eye } from "assets/console/eye.svg";
import { ReactComponent as EyeOff } from "assets/console/eye_off.svg";
import { toastErrorSyle } from "hooks/utils/util";
import Seo from "components/Seo";

const initialLoginData = {
    id: "",
    password: "",
};
export default function ConsoleLogin() {
    // const accessToken = useConsoleAuthStore(state => state.accessToken);
    const navigate = useNavigate();
    const [loginData, setLoginData] = useState(initialLoginData);
    const [visiblePassword, setVisiblePassword] = useState(false);
    const { mutate } = usePostLogin();

    const handleLogin = (e: FormEvent) => {
        e.preventDefault();
        if (!loginData.id || !loginData.password) {
            const message = "로그인정보를 입력해주세요.";
            toast.error(message, toastErrorSyle);
            return;
        }
        mutate(
            { a_id: loginData.id, a_pwd: loginData.password },
            {
                onSuccess: () => {
                    toast.remove();
                    navigate("/air/customer/pickup");
                },
                onError: (error: any) => {
                    let message = error.message;
                    if (error.status === 404) {
                        message = "아이디 또는 비밀번호가 일치하지 않습니다.";
                    }
                    toast.error(message, toastErrorSyle);
                },
            },
        );
    };

    // if (accessToken) {
    //     return <Navigate to="/" replace />;
    // }

    return (
        <>
            <Seo type="console" pageTitle="로그인" />
            <div className="max-h-[100dvh] min-h-[100dvh] flex items-center justify-center">
                <div className="grid grid-cols-[55%_45%] rounded-[20px] bg-white min-w-[1100px] w-[1100px] shadow-[rgba(99,99,99,0.2)_0px_2px_8px_0px]">
                    <div className="flex-1 h-full p-[16px_0_16px_16px]">
                        <figure className="w-full h-full bg-cover rounded-[8px]" style={{ backgroundImage: `url(${MainImage})` }}></figure>
                    </div>
                    <div className="flex-1 w-full max-w-[640px] mx-auto py-[100px] px-[4%]">
                        <div className="w-full max-w-[400px] mx-auto">
                            <div>
                                <div className="flex items-center gap-[10px] justify-center">
                                    <img src={Logo} alt="일신그룹" />
                                </div>
                                {/* <p className="text-[#999999] text-[20px] text-center mt-[7px]">www.ilshingroup.com</p> */}
                                <p className="text-center text-[#1B1C1E] font-[500] text-[24px] mt-6">로그인을 해주세요.</p>
                            </div>
                            <form onSubmit={handleLogin}>
                                <div className="flex flex-col gap-[16px] py-[60px]">
                                    <div className="border border-[#dddddd] rounded-[8px] overflow-hidden px-[12px] py-[16px] flex bg-white [&:has(input:focus)]:ring-2 ring-[#FF7B2E]">
                                        <label htmlFor="id" className="min-w-[80px] text-[#FF7B2E] text-[18px] font-[500]">
                                            아이디
                                        </label>
                                        <input
                                            autoFocus
                                            type="text"
                                            id="id"
                                            value={loginData.id}
                                            onChange={e => setLoginData(pre => ({ ...pre, id: e.target.value }))}
                                            placeholder="아이디를 입력하세요."
                                            className="flex-1 bg-transparent focus:outline-none"
                                        />
                                    </div>
                                    <div className="border border-[#dddddd] rounded-[8px] overflow-hidden px-[12px] py-[16px] flex items-center bg-white [&:has(input:focus)]:ring-2 ring-[#FF7B2E]">
                                        <label htmlFor="password" className="min-w-[80px] text-[#FF7B2E] text-[18px] font-[500]">
                                            비밀번호
                                        </label>
                                        <input
                                            type={visiblePassword ? "text" : "password"}
                                            id="password"
                                            value={loginData.password}
                                            onChange={e => setLoginData(pre => ({ ...pre, password: e.target.value }))}
                                            placeholder="비밀번호를 입력하세요."
                                            className="flex-1 bg-transparent focus:outline-none"
                                        />
                                        <button type="button" onClick={() => setVisiblePassword(prev => !prev)}>
                                            {visiblePassword ? <Eye /> : <EyeOff />}
                                        </button>
                                    </div>
                                </div>
                                <button className="w-full py-[18px] text-white text-[20px] font-bold bg-[linear-gradient(171deg,#FE9257_50.75%,#FE8441_50.76%)] shadow-[4px_4px_8px_0px_#CAD6DE99] rounded-[12px]">
                                    로그인
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
}
